import { createQueryString } from "@repo/lib/utils";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import NProgress from "nprogress";
import { useCallback, useState } from "react";

const useSortBy = () => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleSortBy = useCallback(
    (sortValue) => {
      NProgress.start();
      const updatedQueryString = createQueryString(
        {
          sort: sortValue,
          page: "1", // Reset to the first page when sorting
        },
        searchParams
      );

      router.push(`${pathname}?${updatedQueryString}`);
    },
    [router, pathname, searchParams]
  );

  const handleToggleBottomSheet = useCallback(() => {
    setIsBottomSheetOpen((prev) => !prev);
  }, [setIsBottomSheetOpen]);

  const handleToggleDropdown = useCallback(() => {
    setIsDropdownOpen((prevState) => !prevState);
  }, [setIsDropdownOpen]);

  return {
    handleSortBy,
    isBottomSheetOpen,
    handleToggleBottomSheet,
    isDropdownOpen,
    handleToggleDropdown,
  };
};

export default useSortBy;
